export default __webpack_public_path__ + "static/media/poster14.2f57e5a0.png";